__turbopack_context__.v({
  "button": "VideoButton-module-scss-module__rLD8sW__button",
  "button_black": "VideoButton-module-scss-module__rLD8sW__button_black",
  "button_white": "VideoButton-module-scss-module__rLD8sW__button_white",
});
